var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({ref:"select",on:{"change":_vm.onChange}},'el-select',_vm.$attrs,false),_vm._l((_vm.itemOptions),function(item){return _c('el-option',{key:item.Id,attrs:{"value":item.Code,"label":item.Name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }